import { useAccountValues } from '../../../../providers/AccountProvider';
import * as StyledShared from '../../styles';

export const AuthButtonsFtnftAmLayoutSkeleton = () => {
  const { configs } = useAccountValues();

  return (
    <>
      {!configs?.joinWithOneButton && (
        <StyledShared.AuthButtonSkeleton active />
      )}
      <StyledShared.AuthButtonSkeleton active />
    </>
  );
};
